import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import {
  DateFilter,
  Exchanger,
  ExchangersRequest,
  ExchangersResponse,
} from './types'
import { isAllElementsOfSearchTextNotExist } from '../../../libs/utils'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const changedDateFormat = (date: Date) =>
  `${date?.getFullYear()}-${date?.getMonth() + 1}-${date?.getDate()}`
export const exchangerListMounted = createEvent<ExchangersRequest>()

export const getExchangers = fx<ExchangersRequest, ExchangersResponse>({
  method: 'GET',
  url: `/exchanger`,
})

export const $exchangers = restore<Exchanger[]>(
  getExchangers.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfExchangers = restore(
  getExchangers.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: exchangerListMounted,
  fn: ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
    dateFilter,
  }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'type'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (dateFilter) {
        if ((dateFilter as DateFilter).fromDate) {
          newObj = {
            ...newObj,
            fromDate: (dateFilter as DateFilter).fromDate,
          }
        }

        if ((dateFilter as DateFilter).toDate) {
          newObj = {
            ...newObj,
            toDate: (dateFilter as DateFilter).toDate,
          }
        }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }
    // @ts-ignore
    query['populate'] = `${JSON.stringify(['Exchanger.owner'])}`

    return {
      query,
    }
  },
  target: getExchangers,
})
